import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import App from './App';
import { enableES5 } from 'immer';
import { defineCustomElements } from '@duetds/date-picker/dist/loader';
import { initialise } from 'utils/logger';

enableES5();

defineCustomElements(window);

(async () => {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
})();

// https://github.com/welldone-software/why-did-you-render#installation
// https://github.com/welldone-software/why-did-you-render#usage
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React);
}

ReactDOM.render(<App />, document.getElementById('root'));

if (process.env.REACT_APP_DATA_DOG_TOKEN !== undefined) {
  initialise();
}

if (process.env.NODE_ENV === 'production') {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTMID
  };
  TagManager.initialize(tagManagerArgs);
}
